module.exports = __webpack_public_path__ + "media/images/shop-76f174283f69459981aeb579e8e9e930.png";